
import { urlMiddleware } from './middleware';
import { rootReducer } from './reducers';
import { axiosInstance, axiosInstanceB2B, history, initStore, setupAxios } from '@share/utils';

export const store = initStore(history, rootReducer, urlMiddleware);

setupAxios(axiosInstanceB2B, store, false);
setupAxios(axiosInstance, store, true);
